/**
 * @desc 查询单个产品信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductMasterResponseDto>;
export function request(productNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/byUnique/${productNo}`, {
      method: "POST",

      ...options,
    }),
  );
}
